import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faApple, faChrome, faWindows } from '@fortawesome/free-brands-svg-icons';
import { CSSProperties } from 'react';

export enum GadgetPlaform {
    WINDOWS="WINDOWS",
    MAC="MAC",
    WEB="WEB"
}

interface PlatformIconProps {
    platform: GadgetPlaform,
    size: | "xs" | "sm" | "lg" | "xl" | "2xl",
    style?: CSSProperties
}

export const PlatformIcon = ({ platform, size, style }: PlatformIconProps) => {
    const icons: Record<GadgetPlaform, React.ReactElement> = {
        WINDOWS: <FontAwesomeIcon icon={faWindows} size={size} style={style}/>,
        MAC: <FontAwesomeIcon icon={faApple} size={size} style={style}/>,
        WEB: <FontAwesomeIcon icon={faChrome} size={size} style={style}/>
    };
    const currentPlatformIcon = icons[platform] || <FontAwesomeIcon icon={faWindows} />;

    return currentPlatformIcon;
};